<template>
    <div>
      
        <ViewDocument v-if="!!item"   @success="alertSuccess"></ViewDocument>

        <DocumentTable
            title="Users"
            @addHealth="showDocumentTypeModal"
            ref="table"
        ></DocumentTable>
        
    </div>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'
import DocumentTable from './DocumentTable'
import ViewDocument from './ViewDocument'
// import CreateVehicleForm from './CreateVehicleForm'

export default {
    name: 'Customer-Document',
    mixins: [popupMixins, permissionsMixins],
    components: {
        DocumentTable,
        ViewDocument,
    },
    data: () => {
        return {
            item: null,
            componentName : "Customer Document",
        }
    },
    async mounted(){
        await this.$store.dispatch('user_roster/fetchUsers');
    },

    methods: {
        alertSuccess(action) {
            console.log("asdasda",action)
            console.log(this.item)
            this.genericToast(
                this.componentName,
                action,
                'success',
                `${name} has been succcessfully ${action.toLowerCase()}`
            )
            //this.doToast('Success', `Item ${action}!`, 'success')
            this.item = null
            this.$refs.table.doSearch()
        },
        showDocumentTypeModal() {
            this.$refs.createDocumentType.showModal()
        },
        // created() {
        //     this.doToast('Created!', 'Vehicle Created', 'success')
        //     this.$refs.table.doSearch()
        //     this.$refs.createVehicle.hideModal()
        // },
        handleError(error) {
            this.doToast(this.$translate('error'), error.message, 'danger')
        },
    },
}
</script>
<style></style>
